import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import AppActions from '../App/actions';
import {deleto, get, post, puto} from 'bukku/shared/ApiService';
import {t} from "@lingui/macro";

// Create group
export function* createContactGroupRequest() {
    yield takeEvery(actions.CONTACT_GROUP_CREATE_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(post, '/contacts/groups', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.CONTACT_GROUP_CREATE_SUCCESS,
                data,
            });
        }
        catch (error) {
            yield put({
                type: actions.CONTACT_GROUP_CREATE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* createContactGroupSuccess() {
    yield takeEvery(actions.CONTACT_GROUP_CREATE_SUCCESS, function* () {
        yield message.success(t`The contact group is created.`);
    });
}
export function* createContactGroupError() {
    yield takeEvery(actions.CONTACT_GROUP_CREATE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read group list
export function* readContactGroupListRequest() {
    yield takeEvery(actions.CONTACT_GROUP_READ_LIST_REQUEST, function* (payload, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/contacts/groups', null, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.CONTACT_GROUP_READ_LIST_SUCCESS,
                groups: data.groups,
            });
        }
        catch (error) {
            yield put({
                type: actions.CONTACT_GROUP_READ_LIST_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readContactGroupListSuccess() {
    yield takeEvery(actions.CONTACT_GROUP_READ_LIST_SUCCESS, () => {});
}
export function* readContactGroupListError() {
    yield takeEvery(actions.CONTACT_GROUP_READ_LIST_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read group
export function* readContactGroupRequest() {
    yield takeEvery(actions.CONTACT_GROUP_READ_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, `/contacts/groups/${id}`, null, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.CONTACT_GROUP_READ_SUCCESS,
                group: data.group,
            });
        }
        catch (error) {
            yield put({
                type: actions.CONTACT_GROUP_READ_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readContactGroupSuccess() {
    yield takeEvery(actions.CONTACT_GROUP_READ_SUCCESS, () => {});
}
export function* readContactGroupError() {
    yield takeEvery(actions.CONTACT_GROUP_READ_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Update group
export function* updateContactGroupRequest() {
    yield takeEvery(actions.CONTACT_GROUP_UPDATE_REQUEST, function* ({ id, request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(puto, `/contacts/groups/${id}`, request, context);

            // OK
            yield put({
                type: actions.CONTACT_GROUP_UPDATE_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.CONTACT_GROUP_UPDATE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateContactGroupSuccess() {
    yield takeEvery(actions.CONTACT_GROUP_UPDATE_SUCCESS, function* () {
        yield message.success(t`The contact group is updated.`);
    });
}
export function* updateContactGroupError() {
    yield takeEvery(actions.CONTACT_GROUP_UPDATE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Delete group
export function* deleteContactGroupRequest() {
    yield takeEvery(actions.CONTACT_GROUP_DELETE_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(deleto, `/contacts/groups/${id}`, null, context);

            // OK
            yield put({
                type: actions.CONTACT_GROUP_DELETE_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.CONTACT_GROUP_DELETE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* deleteContactGroupSuccess() {
    yield takeEvery(actions.CONTACT_GROUP_DELETE_SUCCESS, function* () {
        yield message.success(t`The contact group is deleted.`);
    });
}
export function* deleteContactGroupError() {
    yield takeEvery(actions.CONTACT_GROUP_DELETE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(createContactGroupRequest),
        fork(createContactGroupSuccess),
        fork(createContactGroupError),
        fork(readContactGroupListRequest),
        fork(readContactGroupListSuccess),
        fork(readContactGroupListError),
        fork(readContactGroupRequest),
        fork(readContactGroupSuccess),
        fork(readContactGroupError),
        fork(updateContactGroupRequest),
        fork(updateContactGroupSuccess),
        fork(updateContactGroupError),
        fork(deleteContactGroupRequest),
        fork(deleteContactGroupSuccess),
        fork(deleteContactGroupError),
    ]);
}
